import { select } from './select';

/**
 * Since I18n is currently not implemented,
 *  a plural is equivalent to a select, because in english,
 *  there is not a difference in how words are pluralized between "two"/"few" and "other"
 *  I.e, we only need to pluralize for 1 and other
 */
export const plural = select;
